// extracted by mini-css-extract-plugin
module.exports = {"container":"search_commentary_watcher-module__container--xapmM"};